/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ThreeLinesArrowRight(props) {
  return (
    <Icon {...props}>
      <path d="M3,18 L12,18 L12,16 L3,16 L3,18 Z M3,13 L14.5,13 L14.5,11 L3,11 L3,13 Z M3,6 L3,8 L12,8 L12,6 L3,6 Z M14.5617344,15.59 L18.1575208,12 L14.5617344,8.41 L15.977952,7 L21,12 L15.977952,17 L14.5617344,15.59 Z" />
    </Icon>
  )
}

ThreeLinesArrowRight.category = categories.navigation

export default ThreeLinesArrowRight
